import { useEffect, useRef } from "react";

const Intro = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-fade-in-up");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = sectionRef.current?.querySelectorAll(".animate-on-scroll");
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="intro" className="py-16 md:py-20 bg-transparent">
      <div className="container px-6">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          {/* Glass Header Box */}
          <div className="animate-on-scroll opacity-0 translate-y-8 inline-block px-8 py-6 rounded-2xl bg-foreground/5 backdrop-blur-md border border-foreground/10">
            {/* Decorative element */}
            <div className="flex items-center justify-center gap-4 mb-4">
              <span className="w-12 h-px bg-gradient-to-r from-transparent to-highlight" />
              <span className="text-sm tracking-wide uppercase text-label font-medium">
                Philosophie
              </span>
              <span className="w-12 h-px bg-gradient-to-l from-transparent to-highlight" />
            </div>

            {/* Headline */}
            <h2 className="text-heading md:text-display font-serif font-light text-foreground">
              Schönheit beginnt mit <span className="text-highlight font-medium">Qualität</span>
            </h2>
          </div>

          {/* Text with highlighted keywords */}
          <p className="animate-on-scroll opacity-0 translate-y-8 text-lg md:text-xl leading-relaxed text-muted-foreground font-light" style={{ animationDelay: "150ms" }}>
            <span className="font-medium text-foreground">22 Studios</span> steht für{" "}
            <span className="text-highlight font-medium">professionelle Beauty-Behandlungen</span> auf höchstem
            Niveau. Mit <span className="italic text-foreground">hochwertigen Produkten</span>, moderner Technik und einem
            geschulten Blick für <span className="font-medium text-foreground">Ästhetik</span> schaffen wir Looks, die Ihre{" "}
            <span className="text-highlight font-medium">natürliche Schönheit</span> unterstreichen – individuell, stilvoll und zeitlos.
          </p>

          {/* Decorative divider */}
          <div className="animate-on-scroll opacity-0 translate-y-8 pt-8" style={{ animationDelay: "300ms" }}>
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-highlight to-transparent mx-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
